import { render, staticRenderFns } from "./w9.vue?vue&type=template&id=54b04fe8&scoped=true&"
import script from "./w9.vue?vue&type=script&lang=js&"
export * from "./w9.vue?vue&type=script&lang=js&"
import style0 from "./w9.vue?vue&type=style&index=0&id=54b04fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b04fe8",
  null
  
)

export default component.exports